import { Form, Input, InputNumber, Select, Switch } from 'antd'
import type { ServiceChargeInput } from '@super-mega/server/contracts/order'

export function ServiceTermRuleFields({
  rule,
  disabled,
  onChange
}: {
  rule: ServiceChargeInput
  disabled: boolean
  onChange: (patch: Partial<ServiceChargeInput>) => void
}) {
  return (
    <div className="grid grid-cols-1 gap-x-4 sm:grid-cols-3">
      <Form.Item label="费用名称" required>
        <Input
          aria-label="费用名称"
          disabled={disabled}
          value={rule.feeName}
          maxLength={100}
          onChange={(e) => onChange({ feeName: e.target.value })}
        />
      </Form.Item>
      <Form.Item label="费用类型">
        <Select
          aria-label="费用类型"
          disabled={disabled}
          value={rule.feeType}
          options={[
            { label: '服务费', value: 'service' },
            { label: '押金', value: 'deposit' }
          ]}
          onChange={(feeType) => onChange({ feeType, ...(feeType === 'deposit' ? { chargeMode: 'once' } : {}) })}
        />
      </Form.Item>
      <Form.Item label="收费方式">
        <Select
          aria-label="收费方式"
          disabled={disabled || rule.feeType === 'deposit'}
          value={rule.chargeMode}
          options={[
            { label: '周期收费', value: 'recurring' },
            { label: '一次性收费', value: 'once' }
          ]}
          onChange={(chargeMode) => onChange({ chargeMode })}
        />
      </Form.Item>
      <Form.Item label={rule.chargeMode === 'once' ? '约定金额' : '单价'} required>
        <InputNumber
          className="w-full"
          disabled={disabled}
          value={rule.unitPrice}
          min={0}
          precision={2}
          prefix="¥"
          onChange={(price) => onChange({ unitPrice: price ?? 0 })}
        />
      </Form.Item>
      {rule.chargeMode === 'recurring' && (
        <>
          <Form.Item label="计价单位">
            <Select
              aria-label="计价单位"
              disabled={disabled}
              value={rule.pricingUnit}
              options={[
                { label: '元/天', value: 'day' },
                { label: '元/月', value: 'month' }
              ]}
              onChange={(pricingUnit) => onChange({ pricingUnit, cycleUnit: pricingUnit, cycleInterval: 1 })}
            />
          </Form.Item>
          <Form.Item label="出账单位">
            <Select
              aria-label="出账单位"
              disabled={disabled}
              value={rule.cycleUnit}
              options={[
                { label: '天', value: 'day', disabled: rule.pricingUnit === 'month' },
                { label: '月', value: 'month' }
              ]}
              onChange={(cycleUnit) => onChange({ cycleUnit, cycleInterval: 1 })}
            />
          </Form.Item>
          <Form.Item label="每几天／月出账">
            <InputNumber
              aria-label="每几天／月出账"
              disabled={disabled}
              min={1}
              max={rule.cycleUnit === 'day' ? 365 : 12}
              precision={0}
              value={rule.cycleInterval}
              onChange={(cycleInterval) => onChange({ cycleInterval: cycleInterval ?? 1 })}
            />
          </Form.Item>
          {rule.cycleUnit === 'month' && (
            <Form.Item label="账期对齐">
              <Select
                aria-label="账期对齐"
                disabled={disabled}
                value={rule.alignment}
                options={[
                  { label: '自然月', value: 'calendar' },
                  { label: '开通日', value: 'anniversary' }
                ]}
                onChange={(alignment) => onChange({ alignment })}
              />
            </Form.Item>
          )}
          {rule.pricingUnit === 'month' && (
            <Form.Item label="不足月收费">
              <Select
                aria-label="不足月收费"
                disabled={disabled}
                value={rule.prorationMode}
                options={[
                  { label: '按实际天数折算', value: 'actual' },
                  { label: '收整月费用', value: 'full' }
                ]}
                onChange={(prorationMode) => onChange({ prorationMode })}
              />
            </Form.Item>
          )}
        </>
      )}
      <Form.Item label="出账时点">
        <Select
          aria-label="出账时点"
          disabled={disabled}
          value={rule.generationTiming}
          options={[
            { label: '期初', value: 'start' },
            { label: '期末', value: 'end' }
          ]}
          onChange={(generationTiming) => onChange({ generationTiming })}
        />
      </Form.Item>
      <Form.Item label="延后出账天数">
        <InputNumber
          aria-label="延后出账天数"
          disabled={disabled}
          min={0}
          max={365}
          precision={0}
          value={rule.generationOffsetDays}
          onChange={(days) => onChange({ generationOffsetDays: days ?? 0 })}
        />
      </Form.Item>
      <Form.Item label="付款宽限天数">
        <InputNumber
          aria-label="付款宽限天数"
          disabled={disabled}
          min={0}
          max={365}
          precision={0}
          value={rule.dueOffsetDays}
          onChange={(days) => onChange({ dueOffsetDays: days ?? 0 })}
        />
      </Form.Item>
      <Form.Item label="自动生成草稿">
        <Switch
          aria-label="自动生成草稿"
          disabled={disabled}
          checked={rule.autoGeneration}
          onChange={(autoGeneration) => onChange({ autoGeneration })}
        />
      </Form.Item>
    </div>
  )
}
